import React from 'react';

import AdminGeneralForm from './AdminGeneralForm';
import OnUnitAndPlaylistForm from './OnUnitAndPlaylistForm';
import UnitSettingsForm from './UnitSettingsForm';
import AdsSettingsForm from './AdsSettingsForm';
import HumanSettingsForm from './HumanSettingsForm';
import AdsBilling from './AdsBilling';
import StoryStripForm from './StoryStripForm';
// eslint-disable-next-line import/no-named-as-default
import BrandedStoryStripForm from './BrandedStoryStrip/BrandedStoryStrip';
import TrackingSettingsForm from './TrackingSettingsForm';
import AutoDailyUnitForm from './AutoDailyUnitForm';
import AutoPollForm from './AutoPollForm';
import AutoQuizForm from './AutoQuizForm';

const ChannelGeneral = () => (
  <>
    <AdminGeneralForm />

    <OnUnitAndPlaylistForm />

    <UnitSettingsForm />

    <BrandedStoryStripForm />

    <AutoDailyUnitForm />

    <StoryStripForm />

    <AutoPollForm />

    <AutoQuizForm />

    <AdsSettingsForm />

    <HumanSettingsForm />

    <AdsBilling />

    <TrackingSettingsForm />
  </>
);

export default ChannelGeneral;
